import { FilterSingleCheckbox } from '../baseInputTypes/FilterSingleCheckbox'

type Props = {}
export const EPSS = (props: Props) => {
  return (
    <FilterSingleCheckbox
      label="Electric Power Spec Sizer"
      fieldPath="productInformation.electricPowerSpecSizer"
    />
  )
}
